<template>
    <div class="coupon-page p-4">
    
        <!-- POPUP ERROR -->
        <div v-if="isPopupError">
            <div class="popup-all1 text-center">
                <img style="max-width: 100px" src="../assets/img/error.png" />
                <h3 class="custom-32px-500 mt-3 font-color-171717">Oops!</h3>
                <h3 class="custom-18px mt-3">{{ errorMessage }}</h3>
            </div>
        </div>
    
        <!-- PAGE HEADER -->
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h2 class="page-title">Coupon Management</h2>
            <button class="btn btn-primary" @click="openAddPopup">+ Add Coupon</button>
        </div>
    
        <!-- TABLE -->
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Value (RM)</th>
                    <th>Max Used</th>
                    <th>Valid Date</th>
                    <th>Status</th>
                    <th width="120">Action</th>
                </tr>
            </thead>
    
            <tbody>
                <tr v-for="(c, index) in coupons" :key="c.Id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ c.Code }}</td>
                    <td>{{ c.Value }}</td>
                    <td>{{ c.MaxUsed }}</td>
                    <td>{{ formatDate(c.ValidDate) }}</td>
                    <td>
                        <span class="badge" :class="c.Status ? 'badge-success' : 'badge-danger'">
                        {{ c.Status ? "Active" : "Inactive" }}
                      </span>
                    </td>
                    <td>
                        <button class="btn btn-sm btn-info" @click="openEditPopup(c)">
                        Edit
                      </button>
                    </td>
                </tr>
    
                <tr v-if="coupons.length === 0">
                    <td colspan="7" class="text-center text-muted">No coupon found</td>
                </tr>
            </tbody>
        </table>
    
        <!-- CUSTOM POPUP (ADD / EDIT) -->
        <div v-if="popupCoupon" class="modal-backdrop">
            <div class="modal-card popup-all1 p-0">
    
                <!-- HEADER -->
                <div class="modal-header">
                    <h4>{{ isEdit ? "Edit Coupon" : "Add Coupon" }}</h4>
                    <img src="../assets/img/close.png" class="close-btn" @click="closePopup" />
                </div>
    
                <!-- BODY -->
                <div class="modal-body">
    
                    <label>Code</label>
                    <input class="form-control" v-model="form.code" />
    
                    <label class="mt-2">Value (RM)</label>
                    <input class="form-control" type="number" v-model="form.value" />
    
                    <label class="mt-2">Max Used</label>
                    <input class="form-control" type="number" v-model="form.maxUsed" />
    
                    <label class="mt-2">Valid Date</label>
                    <input class="form-control" type="date" v-model="form.validDate" />
    
                    <label class="mt-2">Status</label>
                    <select class="form-control" v-model="form.status">
                      <option :value="true">Active</option>
                      <option :value="false">Inactive</option>
                    </select>
    
                </div>
    
                <!-- FOOTER -->
                <div class="modal-footer d-flex justify-content-end gap-2">
                    <button class="btn btn-secondary" @click="closePopup">Cancel</button>
                    <button class="btn btn-primary" @click="saveCoupon">
                      {{ isEdit ? "Update" : "Submit" }}
                    </button>
                </div>
    
            </div>
        </div>
    
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            coupons: [],
            popupCoupon: false,
            isEdit: false,
            isPopupError: false,
            errorMessage: "",
            form: {
                Id: 0,
                Code: "",
                Value: 0,
                MaxUsed: 0,
                ValidDate: "",
                Status: true,
            },
        };
    },

    mounted() {
        this.loadCoupons();
    },

    methods: {
        async loadCoupons() {
            try {
                this.coupons = [];
                const res = await this.$API.get(this.$GetListCoupon);

                // --- ADD DEBUGGING HERE ---
                console.log("API Response Data:", res.data);
                // --- ADD DEBUGGING HERE ---

                // Check if the response is an array of data, not just an empty array
                if (Array.isArray(res.data)) {
                    this.coupons = res.data;
                } else {
                    // Handle case where API returns something like { data: [...] }
                    this.coupons = res.data.data || [];
                }

            } catch (err) {
                this.showError("Failed to load coupon list");
            }
        },

        openAddPopup() {
            this.isEdit = false;
            // Use the consistent lowercase keys for the form object
            this.form = {
                id: 0,
                code: "",
                value: 0,
                maxUsed: 0,
                validDate: "",
                status: true,
            };
            this.popupCoupon = true;
        },


        openEditPopup(coupon) {
            this.isEdit = true;

            // Map server TitleCase keys to local lowercase form keys
            this.form = {
                id: coupon.Id,
                code: coupon.Code,
                maxUsed: coupon.MaxUsed,
                value: coupon.Value,
                status: coupon.Status,
                validDate: coupon.ValidDate ? coupon.ValidDate.substring(0, 10) : ""
            };

            this.popupCoupon = true;
        },

        closePopup() {
            // Only one place to manage the state
            this.popupCoupon = false;
        },

        showError(msg) {
            this.errorMessage = msg;
            this.isPopupError = true;
            setTimeout(() => (this.isPopupError = false), 2500);
        },
        async saveCoupon() {
            try {
                // Validate
                if (!this.form.code) {
                    return this.showError("Code cannot be empty");
                }

                // Convert to FormData
                const fd = new FormData();
                // Use lowercase keys from this.form, ensure Id is handled for New/Edit
                fd.append("Id", this.form.id || 0);
                fd.append("Code", this.form.code);
                fd.append("Value", this.form.value);
                fd.append("MaxUsed", this.form.maxUsed);
                fd.append("Status", this.form.status);
                fd.append("ValidDate", this.form.validDate);

                const res = await this.$API.post(
                    this.$InsertCoupon,
                    fd, { withCredentials: true }
                );

                // FIX: Clean and direct success handling
                if (res.status === 200 && res.data === "Ok") {
                    this.popupCoupon = false; // 1. Closes the popup (calls popupCoupon = false)
                    await this.loadCoupons(); // 2. Await the list reload
                } else {
                    this.popupCoupon = false; // 1. Closes the popup (calls popupCoupon = false)
                    // Handle server-side validation error passed in the message field
                    return this.showError(res.data.message || "Failed to save coupon.");
                }

            } catch (err) {
                // Better error handling for network/API failures
                const errorMsg = err.response && err.response.data && err.response.data.message ?
                    err.response.data.message :
                    "Failed to save coupon. Check network connection or API status.";
                this.showError(errorMsg);
            }
        },

        formatDate(date) {
            return date ? date.split("T")[0] : "";
        },

        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

    },
};
</script>
  
<style scoped>
.table th,
.table td {
    vertical-align: middle;
}

/* Your popup styling reused */

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-card {
    width: 450px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
}
</style>